export interface IRole {
  id: string;
  name: string;
  description: any;
  target: RoleAuthTarget;
  targetId: string;
  entityId: string;
  permissions: string[];
}

export type roleAuthorizationTarget =
  | 'Administration'
  | 'Entity'
  | 'Location'
  | 'Vehicle';

export enum RoleAuthTarget {
  // tslint:disable-next-line:no-bitwise
  Administration = 1 << 0,
  // tslint:disable-next-line:no-bitwise
  Entity = 1 << 1,
  // tslint:disable-next-line:no-bitwise
  Location = 1 << 2,
  // tslint:disable-next-line:no-bitwise
  Vehicle = 1 << 3,
}

export interface IAssignedAdminRoles {
  id: string;
  firstName: string;
  surname: string;
  roles: IRole[];
  updatedAt: Date;
  createdAt: Date;
}

// Used for locations and vehicles CRUD role
export interface IRoleSetViewModel {
  id: string;
  title: string;
  roles: IRolesViewModel[];
}

// Used for admin CRUD role
export interface IRolesViewModel {
  id: string;
  title: string;
  assigned: boolean;
}
